'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getFirstTemplate = require('./getFirstTemplate');

var _getFirstTemplate2 = _interopRequireDefault(_getFirstTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFirstButtonText = function getFirstButtonText(message) {
  var button = (0, _getFirstTemplate2.default)(message).templateButtons.first();
  return button && button.title;
};

exports.default = getFirstButtonText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/chat-rich-template/getFirstButtonText.js
// module id = 1122
// module chunks = 2 3